import styled from 'styled-components';

export const Favorite = styled.img`
  width: 100%;
  height: 100%;
`;
